// extracted by mini-css-extract-plugin
module.exports = {"hidden":"hidden__3zj4d","select":"select__TDF8Y","select-button":"select-button__2PrWG","text":"text__P_elf"};